<div>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col-auto">
          <mat-form-field class="fullwidth">
            <label>{{ 'Sök' | translate }}</label>
            <input matInput [(ngModel)]="searchText">
          </mat-form-field>
        </div>
        <div class="col">
          <br />
          <button mat-raised-button color="primary" (click)="search()">{{ 'Sök' | translate }}</button>
        </div>
      </div>
    </div>
    <div class="col-6 align-right">
      <br />
      <!--
      <button mat-raised-button color="primary" (click)="copyAllSKU()">
        <ng-container *ngIf="!allCopied">
          <span class="material-symbols-outlined">content_paste</span>{{ 'Kopiera alla SKU' | translate }}</ng-container>
        <ng-container *ngIf="allCopied">
          <span class="material-symbols-outlined">check</span>{{ 'Kopierad!' | translate }}</ng-container>
      </button>
      <button mat-raised-button color="primary" (click)="copyAllURL()">
        <ng-container *ngIf="!allUrlCopied">
          <span class="material-symbols-outlined">content_paste</span>{{ 'Kopiera alla URL:er' | translate }}</ng-container>
        <ng-container *ngIf="allUrlCopied">
          <span class="material-symbols-outlined">check</span>{{ 'Kopierad!' | translate }}</ng-container>
      </button> -->
    </div>
  </div>
  <div class="row">

    <div class="col-12">
      <table class="fullwidth styled">
        <tr>
          <th>{{ 'Skapad' | translate }}</th>
          <th>{{ 'Uppdaterad' | translate }}</th>
          <th>{{ 'Namn' | translate }}</th>
          <th class="align-right">{{ 'Storlek' | translate }}</th>

        </tr>
        <tr *ngFor="let file of printFiles">
          <td>{{file.created | date: 'yyyy-MM-dd HH:mm'}}</td>
          <td>
            <span *ngIf="file.updated">{{file.updated | date: 'yyyy-MM-dd HH:mm'}}</span>
          </td>
          <td>
            <a [routerLink]="[globals.panelUrl('/print-files/' + file._id)]">
              <span *ngIf="file.sku">{{file.sku}}</span>
              <span *ngIf="!file.sku">{{file.fileName}}</span>
            </a>
          </td>
          <td class="align-right">
            {{file.posterSize}}
            <!--
            <button mat-raised-button color="primary" (click)="copySKU(file.fileName)">
              <ng-container *ngIf="file.fileName != copiedFileName">
                <span class="material-symbols-outlined">content_paste</span>{{ 'Kopiera SKU' | translate }}</ng-container>
              <ng-container *ngIf="file.fileName == copiedFileName">
                <span class="material-symbols-outlined">check</span>{{ 'Kopierad!' | translate }}</ng-container>
            </button>
            <button mat-raised-button color="primary" (click)="copyURL(file.url)">
              <ng-container *ngIf="file.url != copiedUrl">
                <span class="material-symbols-outlined">content_paste</span>{{ 'Kopiera URL' | translate }}</ng-container>
              <ng-container *ngIf="file.url == copiedUrl">
                <span class="material-symbols-outlined">check</span>{{ 'Kopierad!' | translate }}</ng-container>
            </button>
          -->
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
